export default __webpack_public_path__ + "assets/community-one-three.94a2ef7f899390e7a4463718978d5a46.png";